import React from "react";
import Seo from "@/components/Seo";

const Box = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-heading font-bold text-xl sm:text-2xl text-slate-900 mb-3">{title}</h2>
    <div className="text-slate-700 leading-relaxed space-y-3">{children}</div>
  </section>
);

const TermsPage = () => (
  <>
    <Seo titleKey="seo.cgv_title" descKey="seo.cgv_desc" path="/cgv" />
    <section className="container-x max-w-3xl pt-12 pb-20">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">Légal</p>
      <h1 className="mt-2 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl text-slate-900">
        Conditions Générales de Vente
      </h1>
      <p className="mt-4 text-slate-600">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>

      <div className="mt-8">
        <Box title="Article 1 -Objet">
          <p>Les présentes Conditions Générales de Vente régissent les relations entre BIONET SOLUTIONS et toute personne physique ou morale (ci-après « le Client ») souscrivant aux prestations de nettoyage proposées par la société.</p>
        </Box>

        <Box title="Article 2 -Devis">
          <p>Toute prestation fait l'objet d'un devis gratuit et personnalisé, valable 30 jours à compter de son émission. Le devis détaille la nature des prestations, le tarif, les délais et les conditions d'intervention. La signature du devis ou tout accord exprès du Client vaut acceptation pleine et entière des présentes CGV.</p>
        </Box>

        <Box title="Article 3 -Tarifs">
          <p>Les tarifs sont exprimés en euros, hors taxes, et précisés sur le devis. La TVA applicable et tout supplément éventuel (urgence, accès difficile, déplacement) y figurent expressément.</p>
        </Box>

        <Box title="Article 4 -Délais et exécution">
          <p>Les délais d'intervention sont fournis à titre indicatif. BIONET SOLUTIONS s'engage à mobiliser ses équipes dans les meilleurs délais, en particulier pour les interventions d'urgence. Le Client s'engage à fournir un accès libre aux locaux et les conditions matérielles nécessaires (eau, électricité).</p>
        </Box>

        <Box title="Article 5 -Paiement">
          <p>Le paiement est dû selon l'échéance indiquée sur la facture (généralement 30 jours fin de mois pour les professionnels et au jour de l'intervention pour les particuliers). En cas de retard, des pénalités au taux d'intérêt légal majoré, ainsi qu'une indemnité forfaitaire de 40 € pour frais de recouvrement (article L441-10 du Code de commerce), sont applicables.</p>
        </Box>

        <Box title="Article 6 -Annulation et report">
          <p>Toute annulation ou report doit être notifié au moins 48 heures avant la date prévue. Une annulation tardive pourra donner lieu à une facturation forfaitaire correspondant à 30% du devis, à titre d'indemnité de mobilisation.</p>
        </Box>

        <Box title="Article 7 -Responsabilité">
          <p>BIONET SOLUTIONS est assuré en responsabilité civile professionnelle. La société s'engage à apporter le plus grand soin à l'exécution de ses prestations. La responsabilité de la société ne saurait être engagée pour les dégâts liés à des objets fragiles non signalés, à des défauts préexistants ou à des conditions extérieures (intempéries, pannes).</p>
        </Box>

        <Box title="Article 8 -Confidentialité et discrétion">
          <p>BIONET SOLUTIONS s'engage à respecter une stricte confidentialité concernant l'ensemble des informations recueillies dans le cadre des prestations, en particulier pour les interventions sensibles (après décès, syndrome de Diogène, sinistre).</p>
        </Box>

        <Box title="Article 9 -Réclamations">
          <p>Toute réclamation doit être adressée à <a href="mailto:contact@bionet-solutions.com" className="text-brand-blue hover:underline">contact@bionet-solutions.com</a> dans un délai de 7 jours après l'intervention. Une solution amiable sera recherchée en priorité.</p>
        </Box>

        <Box title="Article 10 -Droit applicable et juridiction">
          <p>Les présentes CGV sont soumises au droit français. À défaut d'accord amiable, tout litige sera porté devant les tribunaux compétents du ressort du siège social de BIONET SOLUTIONS (Bourg-en-Bresse).</p>
        </Box>

        <Box title="Article 11 -Médiation et droit de rétractation (consommateurs)">
          <p>Conformément à l'article L612-1 du Code de la consommation, le Client consommateur peut recourir gratuitement au service de médiation. Le droit de rétractation de 14 jours s'applique aux contrats conclus à distance, sauf si le Client demande expressément l'exécution avant la fin du délai.</p>
        </Box>
      </div>

      <p className="mt-8 text-xs text-slate-400">Pour toute question sur ces conditions, contactez-nous à <a href="mailto:contact@bionet-solutions.com" className="underline">contact@bionet-solutions.com</a> -BIONET SOLUTIONS SAS, 64 chemin de Sermenaz, 01700 Neyron.</p>
    </section>
  </>
);

export default TermsPage;
